var _style, _g, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElectorateDetails = function SvgElectorateDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "electorate-details_svg__Light",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".electorate-details_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "electorate-details_svg___Group_"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 6,
    className: "electorate-details_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.5V17c0-.3-.2-.5-.5-.5h-1M16.8 14c.1 0 .2.1.2.2s-.1.2-.2.2-.2-.1-.2-.2 0-.2.2-.2M16 20.5h3",
    className: "electorate-details_svg__st0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 4.7,
    r: 4.2,
    className: "electorate-details_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.5h-8c0-3.9 3.1-7 7-7 1.3 0 2.7.4 3.8 1.1",
    className: "electorate-details_svg__st0"
  })));
};
export default SvgElectorateDetails;